"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const AsyncActionImageLoad_1 = require("../../../pullstate/client-async-actions/AsyncActionImageLoad");
const useSingleRun_1 = require("../../hooks/useSingleRun");
const FelaFlexbox_1 = require("../fela/FelaFlexbox");
exports.SimpleImage = react_1.default.memo(({ alt, children, src, aspect, style, maxOpacity = 1, fadeSpeed = "0.2s", onImageLoad, imageFit, objectPosition, outerProps, imgStyle, absolute = false, ...imgProps }) => {
    const imageLoad = AsyncActionImageLoad_1.AsyncActionImageLoad.use({ src }, { ssr: false });
    const runOnceImageLoaded = (0, useSingleRun_1.useSingleRun)();
    imageLoad.renderPayload(() => {
        runOnceImageLoaded(onImageLoad);
    });
    if (absolute) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { style: {
                        position: "absolute",
                        objectFit: imageFit ?? "cover",
                        height: "100%",
                        width: "100%",
                        objectPosition: objectPosition ?? "top",
                        opacity: !imageLoad.error ? maxOpacity : 0,
                        transition: `opacity ${fadeSpeed} ease-in-out`,
                        ...style,
                        ...imgStyle,
                    }, src: src, alt: alt, ...imgProps }), children] }));
    }
    if (aspect) {
        const { style, ...rest } = outerProps ?? {};
        return ((0, jsx_runtime_1.jsxs)(FelaFlexbox_1.FelaFlexbox, { align: "flex-start", position: "relative", style: { paddingBottom: `${100 / aspect}%`, width: "100%", overflow: "hidden", ...style }, ...rest, children: [(0, jsx_runtime_1.jsx)("img", { style: {
                        position: "absolute",
                        objectFit: imageFit ?? "cover",
                        height: "100%",
                        width: "100%",
                        objectPosition: objectPosition ?? "top",
                        opacity: !imageLoad.error ? maxOpacity : 0,
                        transition: `opacity ${fadeSpeed} ease-in-out`,
                        ...style,
                        ...imgStyle,
                    }, src: src, alt: alt, ...imgProps }), children] }));
    }
    return ((0, jsx_runtime_1.jsxs)(FelaFlexbox_1.FelaFlexbox, { align: "flex-start", ...outerProps, children: [(0, jsx_runtime_1.jsx)("img", { style: {
                    objectFit: imageFit,
                    height: "100%",
                    width: "100%",
                    objectPosition: objectPosition ?? "top",
                    opacity: !imageLoad.error ? maxOpacity : 0,
                    transition: `opacity ${fadeSpeed} ease-in-out`,
                    ...style,
                    ...imgStyle,
                }, src: src, alt: alt, ...imgProps }), children] }));
});
